<div *ngIf="_edm.editing" class="inline" style="margin-top: 12px;">
    <span class="display-block bold" style="color: #0068b1; margin-left: 4px;">{{_pageTitle}}</span>
</div>

<div>
    <span class="bold page-subtitle" style="margin-left: 2px; margin-top: 4px;">{{_validationMessage}}</span>
</div>
<div style="margin-top: 12px; margin-left: -8px;">
    <editor-header [edm]="_edm" [customButtons]="true">
        <span customButtons class="inline" style="margin-left: 10px; margin-top: 6px;">
            <button *ngIf="showSaveButton()" type="button" class="btn btn-sm btn-primary" [disabled]="!canSave()" (click)="onSave()">Save</button>
            <button *ngIf="canDelete()" type="button" class="btn btn-sm btn-primary" (click)="onDelete()">Confirm NCS Comment Deletion</button>
            <button *ngIf="!_parentData.deleting && (_parentData.adding || _parentData.editing)" type="button" class="btn btn-sm btn-primary" [disabled]="!canApply()" (click)="onApply()">Apply</button>
            <button *ngIf="canShowBack()" type="button" class="btn btn-sm btn-primary" (click)="onBack()">Back</button>
            <button *ngIf="canCancel()" type="button" class="btn btn-sm btn-primary" (click)="onCancel()">Cancel</button>
        </span>
    </editor-header>
</div>

<div *ngIf="!_parentData.deleting && (this._parentData.editing || this._parentData.adding)">
    <div class="form-group  row">
        <edit-prop label="NCS Comment" prop="comments" szs="1,6">
            <textarea class="form-control" rows=3 type="text" [(ngModel)]="_edm.currentEntity.comments"></textarea>
        </edit-prop>
    </div>
</div>

